var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "sc-page-base",
        { attrs: { title: "Auditoria de faturas" } },
        [
          _c(
            "sc-field",
            [
              _c(
                "router-link",
                {
                  staticClass: "button is-primary",
                  attrs: { to: { name: "invoice-audit-new" } }
                },
                [_vm._v("Nova fatura")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "box" },
            [
              _c(
                "sc-field",
                { attrs: { grouped: "" } },
                [
                  _c(
                    "sc-field",
                    { attrs: { label: "Fatura", expanded: "" } },
                    [
                      _c("sc-input", {
                        attrs: {
                          type: "search",
                          placeholder: "Número da fatura"
                        },
                        model: {
                          value: _vm.filters.invoiceNumber,
                          callback: function($$v) {
                            _vm.$set(_vm.filters, "invoiceNumber", $$v)
                          },
                          expression: "filters.invoiceNumber"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "sc-field",
                    { attrs: { label: "Status", expanded: "" } },
                    [
                      _c("sc-invoice-audit-dropdown-status", {
                        attrs: { "option-all": true },
                        model: {
                          value: _vm.filters.state,
                          callback: function($$v) {
                            _vm.$set(_vm.filters, "state", $$v)
                          },
                          expression: "filters.state"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "sc-field",
                    { attrs: { label: "Transportadora", expanded: "" } },
                    [
                      _c("sc-logistic-provider-dropdown", {
                        attrs: { "option-all": true },
                        model: {
                          value: _vm.filters.logisticProviderId,
                          callback: function($$v) {
                            _vm.$set(_vm.filters, "logisticProviderId", $$v)
                          },
                          expression: "filters.logisticProviderId"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "sc-field",
                    { attrs: { label: "Data de criação", expanded: "" } },
                    [
                      _c("sc-range-date-picker", {
                        attrs: { format: _vm.formartDateToTimestamp },
                        model: {
                          value: _vm.filters.created,
                          callback: function($$v) {
                            _vm.$set(_vm.filters, "created", $$v)
                          },
                          expression: "filters.created"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "sc-field",
                    { attrs: { label: "Data de vencimento", expanded: "" } },
                    [
                      _c("sc-range-date-picker", {
                        attrs: { format: _vm.formartDateToTimestamp },
                        model: {
                          value: _vm.filters.due_date,
                          callback: function($$v) {
                            _vm.$set(_vm.filters, "due_date", $$v)
                          },
                          expression: "filters.due_date"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "box" },
            [
              _c(
                "sc-table",
                {
                  staticClass: "invoice-audit__table",
                  attrs: {
                    loading: _vm.loadingInvoices,
                    data: _vm.invoices,
                    paginated: true,
                    "backend-pagination": true,
                    total: _vm.totalInvoices,
                    "per-page": _vm.filters.limit,
                    "current-page": _vm.filters.page
                  },
                  on: {
                    "page-change": function(page) {
                      return (_vm.filters.page = page)
                    },
                    select: _vm.selectInvoice
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(props) {
                        return [
                          _c(
                            "sc-table-column",
                            {
                              attrs: {
                                field: "state_description",
                                label: "Status",
                                centered: false,
                                sortable: ""
                              }
                            },
                            [
                              _c("sc-invoice-audit-tag-status", {
                                attrs: { status: props.row.state }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "sc-table-column",
                            {
                              attrs: {
                                field: "markers",
                                label: "Marcador",
                                sortable: false
                              }
                            },
                            [
                              props.row.markers.length > 0
                                ? _c(
                                    "div",
                                    { staticClass: "tags is-centered" },
                                    _vm._l(props.row.markers, function(
                                      marker,
                                      index
                                    ) {
                                      return _c("sc-recon-marker", {
                                        key: index,
                                        attrs: { marker: marker }
                                      })
                                    })
                                  )
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "sc-table-column",
                            {
                              attrs: {
                                field: "number",
                                label: "Fatura",
                                sortable: ""
                              }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(props.row.number) +
                                  "\n            "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "sc-table-column",
                            {
                              attrs: {
                                field: "divergence",
                                label: "Divergência",
                                sortable: ""
                              }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm._f("percent")(props.row.divergence)
                                  ) +
                                  "\n            "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "sc-table-column",
                            {
                              attrs: {
                                field: "logistic_provider.name",
                                label: "Transportadora",
                                sortable: ""
                              }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(props.row.logistic_provider.name) +
                                  "\n            "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "sc-table-column",
                            {
                              attrs: {
                                field: "created",
                                label: "Data criação",
                                sortable: ""
                              }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm._f("date")(
                                      props.row.created,
                                      "DD/MM/YYYY HH:mm"
                                    )
                                  ) +
                                  "\n            "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "sc-table-column",
                            {
                              attrs: {
                                field: "due_date",
                                label: "Data vencimento",
                                sortable: ""
                              }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm._f("date")(props.row.due_date)) +
                                  "\n            "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "sc-table-column",
                            {
                              attrs: {
                                field: "dueDate",
                                label: "Arquivos",
                                sortable: false
                              }
                            },
                            [
                              _c(
                                "sc-dropdown",
                                {
                                  attrs: {
                                    position: "is-bottom-left",
                                    hoverable: ""
                                  }
                                },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "button",
                                      attrs: {
                                        slot: "trigger",
                                        type: "button"
                                      },
                                      slot: "trigger"
                                    },
                                    [
                                      _c("span", [_vm._v("Opções")]),
                                      _vm._v(" "),
                                      _c("sc-icon", {
                                        attrs: { icon: "caret-down" }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  props.row.cte_url
                                    ? _c(
                                        "a",
                                        {
                                          staticClass:
                                            "dropdown-item has-text-left",
                                          on: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                              _vm.downloadInvoiceFilePerUrl(
                                                props.row.cte_url
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c("sc-icon", {
                                            attrs: {
                                              icon: "cloud-download-alt"
                                            }
                                          }),
                                          _vm._v(
                                            "\n                  Baixar arquivo original CT-e\n                "
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  props.row.input_url
                                    ? _c(
                                        "a",
                                        {
                                          staticClass:
                                            "dropdown-item has-text-left",
                                          on: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                              _vm.downloadInvoiceFilePerUrl(
                                                props.row.input_url
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c("sc-icon", {
                                            attrs: {
                                              icon: "cloud-download-alt"
                                            }
                                          }),
                                          _vm._v(
                                            "\n                  Baixar arquivo original da fatura\n                "
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  props.row.result_url
                                    ? _c(
                                        "a",
                                        {
                                          staticClass:
                                            "dropdown-item has-text-left",
                                          on: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                              _vm.downloadInvoiceFilePerUrl(
                                                props.row.result_url
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c("sc-icon", {
                                            attrs: {
                                              icon: "cloud-download-alt"
                                            }
                                          }),
                                          _vm._v(
                                            "\n                  Baixar arquivo de análise\n                "
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  !props.row.result_url
                                    ? _c(
                                        "a",
                                        {
                                          staticClass:
                                            "dropdown-item has-text-left",
                                          on: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                              _vm.generateAnalyzeFile(
                                                props.row.id
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c("sc-icon", {
                                            attrs: {
                                              icon: "cloud-download-alt"
                                            }
                                          }),
                                          _vm._v(
                                            "\n                  Gerar arquivo de análise\n                "
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      }
                    }
                  ])
                },
                [
                  _c(
                    "template",
                    { attrs: { slot: "empty" }, slot: "empty" },
                    [_c("sc-table-empty")],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "template",
                    { attrs: { slot: "bottom-left" }, slot: "bottom-left" },
                    [
                      _c("sc-table-per-page", {
                        model: {
                          value: _vm.filters.limit,
                          callback: function($$v) {
                            _vm.$set(_vm.filters, "limit", $$v)
                          },
                          expression: "filters.limit"
                        }
                      })
                    ],
                    1
                  )
                ],
                2
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "sc-modal",
        {
          attrs: { active: _vm.showModal },
          on: {
            "update:active": function($event) {
              _vm.showModal = $event
            }
          }
        },
        [
          _c(
            "sc-modal-card",
            [
              _c("template", { attrs: { slot: "title" }, slot: "title" }, [
                _c("b", { staticClass: "modal-title" }, [
                  _vm._v("Aviso de Migração")
                ])
              ]),
              _vm._v(" "),
              _c("template", { attrs: { slot: "body" }, slot: "body" }, [
                _c("div", { staticClass: "media" }, [
                  _c("div", { staticClass: "media-left" }, [
                    _c(
                      "span",
                      { staticClass: "icon has-text-warning is-large" },
                      [
                        _c("sc-icon", {
                          attrs: {
                            pack: "fas",
                            icon: "exclamation-circle",
                            size: "is-large",
                            type: "is-warning"
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "media-content" }, [
                    _c("p", [
                      _vm._v(
                        'O módulo de Auditoria (1.0) foi migrado definitivamente para o módulo 2.0. A realização de novas auditorias deverá ser feita pela aba de "Conciliação de Frete" dentro da plataforma. Nessa nova versão é possível auditar os custos de frete pré-fatura de forma mais automatizada.\nPara mais informações e dúvidas sobre o uso da nova versão e seus ajustes de configuração, procure o time Intelipost. '
                      )
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("template", { attrs: { slot: "footer" }, slot: "footer" }, [
                _c(
                  "div",
                  { staticClass: "footer-warning" },
                  [
                    _c(
                      "sc-checkbox",
                      {
                        model: {
                          value: _vm.disableAviso,
                          callback: function($$v) {
                            _vm.disableAviso = $$v
                          },
                          expression: "disableAviso"
                        }
                      },
                      [
                        _vm._v(
                          "Não gostaria de receber este aviso novamente durante a sessão"
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "button is-warning",
                        on: {
                          click: function($event) {
                            _vm.showModal = false
                          }
                        }
                      },
                      [_c("b", [_vm._v("Entendi")])]
                    )
                  ],
                  1
                )
              ])
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-28754768", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28754768","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-recon/features/invoice-audit/PageInvoiceAudit.vue
// module id = null
// module chunks = 